import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { getIsAuthenticated, getPointsBalance } from 'store/user/userSelectors';
import { getPointsAmount } from 'store/checkout/checkoutSelectors';
import InsufficientPoints from './InsufficientPoints';
import LoginPrompt from './LoginPrompt';
import { default as WelcomeMessage } from 'pages/Checkout/LoginMessaging';

const ClassicMessaging = ({ quote }) => {
  const isAuthenticated = useSelector(getIsAuthenticated);
  const pointsBalance = useSelector(getPointsBalance);
  const points = useSelector(getPointsAmount);
  const { property, roomType } = quote;
  const hasSufficientPoints = points.lessThanOrEqualTo(pointsBalance);

  if (isAuthenticated && !hasSufficientPoints) {
    return <InsufficientPoints />;
  } else if (isAuthenticated && hasSufficientPoints) {
    return <WelcomeMessage />;
  } else {
    return <LoginPrompt propertyName={property.name} roomType={roomType} pointsCost={points.toNumber()} />;
  }
};

ClassicMessaging.propTypes = {
  quote: PropTypes.shape({
    property: PropTypes.object,
    roomType: PropTypes.object,
  }).isRequired,
};

export default ClassicMessaging;
